import { MenuNode, MenuNodeMeta } from '.'

export const Menus: MenuNode[] = [
  new MenuNode({
    id: 1,
    name: 'home',
    meta: new MenuNodeMeta({ icon: 'o_home', title: '首頁' }),
  }),
  /* TODO: CYBSS-480 CYBSS-482
  new MenuNode({
    id: 2,
    name: 'member_profile',
    meta: new MenuNodeMeta({ icon: 'person', title: '我的帳戶' }),
  }),*/
  new MenuNode({
    id: 3,
    name: 'subscription_management',
    meta: new MenuNodeMeta({ icon: 'credit_card', title: '我的訂閱' }),
  }),
  new MenuNode({
    id: 4,
    name: 'gup_statistics',
    meta: new MenuNodeMeta({ icon: 'sym_o_monitoring', title: '數據後台' }),
    children: [
      new MenuNode({
        id: 41,
        name: 'gup_statistics_overview',
        meta: new MenuNodeMeta({ title: '總覽' })
      }),
      new MenuNode({
        id: 42,
        name: 'point_issue_analysis',
        meta: new MenuNodeMeta({ title: '集點卡發放流量' })
      }),
      new MenuNode({
        id: 43,
        name: 'point_redeem_analysis',
        meta: new MenuNodeMeta({ title: '集點卡兌換流量' })
      }),
      new MenuNode({
        id: 44,
        name: 'point_record',
        meta: new MenuNodeMeta({ title: '集點卡交易紀錄' })
      }),
      // new MenuNode({
      //   id: 45,
      //   name: 'point_member_rank',
      //   meta: new MenuNodeMeta({ title: '集點卡會員等級' })
      // }),
      new MenuNode({
        id: 46,
        name: 'course_data_analysis',
        meta: new MenuNodeMeta({ title: '課程卡數據流量' })
      }),
      new MenuNode({
        id: 47,
        name: 'course_record',
        meta: new MenuNodeMeta({ title: '課程卡交易紀錄' })
      }),
      // new MenuNode({
      //   id: 48,
      //   name: 'course_student_report',
      //   meta: new MenuNodeMeta({ title: '課程學員報表' })
      // }),
      new MenuNode({
        id: 49,
        name: 'customer_report',
        meta: new MenuNodeMeta({ title: '顧客報表' })
      }),
    ]
  }),
  new MenuNode({
    id: 900,
    name: 'helpdesk',
    meta: new MenuNodeMeta({ icon: 'help', title: '服務中心' }),
  }),
]
